import { LabelHTMLAttributes } from 'react';
import { Label } from './Label.style';
import { Tooltip } from '@components/Tooltip';

interface FormLabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  children: React.ReactNode;
  tooltip?: {
    title: string;
    content: string;
  };
}

export default function FormLabel({ children, ...props }: FormLabelProps) {
  return (
    <Label {...props}>
      {children}
      {props.tooltip && <Tooltip title={props.tooltip.title} content={props.tooltip.content} />}
    </Label>
  );
}
